var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0341 8.2313L10.0993 5.29651L7.16449 8.2313C6.85533 8.54044 6.85533 9.04172 7.16449 9.35087C7.47366 9.66002 7.97491 9.66002 8.28408 9.35087L10.0993 7.53568L11.9145 9.35087C12.2236 9.66002 12.7249 9.66002 13.0341 9.35087C13.3432 9.04172 13.3432 8.54044 13.0341 8.2313Z",
    fill: "#47D881"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0341 12.9813L10.0993 10.0465L7.16449 12.9813C6.85533 13.2904 6.85533 13.7917 7.16449 14.1009C7.47366 14.41 7.97491 14.41 8.28408 14.1009L10.0993 12.2857L11.9145 14.1009C12.2236 14.41 12.7249 14.41 13.0341 14.1009C13.3432 13.7917 13.3432 13.2904 13.0341 12.9813Z",
    fill: "#47D881"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.67dc0d777ee649a5bab870ce59f9f946.svg";
export { ForwardRef as ReactComponent };